import Header from "../global/components/Header";
import Footer from '../global/components/Footer';
import { DirectoryProvider } from "./contexts/DirectoryContext";
import { DirectorySearchProvider } from "./contexts/DirectorySearchContext";
import { AuthenticationProvider } from "../global/contexts/AuthenticationContext";
import { UserInfoProvider } from "../global/contexts/UserInfoContext";
import DirectoryLandingPage from "../memberDirectory/components/DirectoryLandingPage";

//This component sets up the member directory application by calling the Header,
//AuthenticationProvider, AuthorizationProvider, DirectoryProvider, DirectorySearchProvider, and DirectoryLandingPage components.
export default function DirectoryApp() {
    console.log("env: " + process.env.NODE_ENV);
    return (
        <>
            <Header message={"Member Directory"} />
            <AuthenticationProvider>
                    <UserInfoProvider>
                    <DirectoryProvider>
                        <DirectorySearchProvider>
                            <DirectoryLandingPage />
                        </DirectorySearchProvider>
                    </DirectoryProvider>
                    </UserInfoProvider>
            </AuthenticationProvider>
            <Footer />
        </>
    );
}